import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "hooks/useAuth";
import paths from "routes/paths";

const ProtectedRoute = ({ children }) => {
  const { account, isLoading } = useAuth();

  // Afficher un spinner pendant le chargement
  if (isLoading) {
    return (
      <div className="spinner-container">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  // Rediriger vers la page de login si l'utilisateur n'est pas connecté
  if (!account) {
    return <Navigate to={paths.login} replace />;
  }

  // Afficher le contenu protégé si l'utilisateur est connecté
  return children;
};

export default ProtectedRoute;
